<template>
  <icon-dropdown icon='columns'>
    <li v-for="(item, index) in headers" v-if="!item.alwaysVisible" :key="index" @click.stop="columnMenuItemClicked(index)">
      <font-awesome-icon v-if="headerVisible(item.visible)" :icon="['far', 'check-square']" aria-label="Checkbox checked"></font-awesome-icon>
      <font-awesome-icon v-else :icon="['far', 'square']" aria-label="Checkbox unchecked"></font-awesome-icon>
      {{item.text}}
    </li>
  </icon-dropdown>
</template>

<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import IconDropdown from '@atoms/IconDropdown'

  export default {
    components: {
      FontAwesomeIcon,
      IconDropdown
    },
    props: {
      headers: Array
    },
    methods: {
      headerVisible (visibility) {
        return (visibility === undefined || visibility)
      },
      columnMenuItemClicked (clickedItemIndex) {
        let headers = [...this.$props.headers]
        let visibility = headers[clickedItemIndex]['visible']
        headers[clickedItemIndex]['visible'] = !((visibility === undefined || visibility === true))
        this.$emit('updateHeaders', headers)
      }
    }
  }
</script>
